/* eslint-disable @typescript-eslint/no-empty-function */
import {getOffset} from "../helpers/html-utils"
/* Class part of the grid system, it will give a width to element based on window width */

interface ResizeObserverProps {
    element: HTMLElement
    last: number
}

export default class ResizeObserver {
    private elements: ResizeObserverProps[] = []
    private sizes = [0,540,720,960,1200]
    private classes = ["","small","medium","large","extra"]
    constructor() {}
    observe(element: HTMLElement):void {
        const obj: ResizeObserverProps = {
            element,
            last: -1
        };
        this.elements.push(obj);
    }
    launch():void {
       for(const element of this.elements) {
            this.apply(element)
       }
    }
    apply(element:ResizeObserverProps):void {
        const widthElt = getOffset(element.element).width;
        let idx = 0;
       for (let i = 0; i < this.sizes.length; i++) {
         if (widthElt >= this.sizes[i]) {
           idx = i;
         }
       }
       if(element.last == -1) {
           element.last = 0;
       }
       if(element.last < idx) {
           for(let i = element.last; i < idx; i++) {
               if(i !== 0) {
                   element.element.classList.add(this.classes[i])
               }
           }
       } else {
           for(let i = element.last; i > idx; i--) {
                if(i !== 0) {
                   element.element.classList.remove(this.classes[i])
               }
           }
       }
       element.last = idx;
    }
}